/**
 * AI activity dashboard API client. Consumes the read-only summary endpoint
 * GET /api/v1/integrations/ai-assistant/activity?days=N. Powers the clinic-
 * owner "what's the AI doing today?" page.
 */
import { apiClient } from "./client";

export interface IntakeDraftStats {
  created: number;
  converted: number;
  discarded: number;
  pending: number;
  conversionRate?: number;
}

export interface HandoffStats {
  created: number;
  pending: number;
  accepted: number;
  completed: number;
  cancelled: number;
}

export interface DailyCount {
  /** ISO date in Asia/Ho_Chi_Minh, e.g. "2026-05-24". */
  date: string;
  count: number;
}

export interface ActivityEntry {
  /** "intake_draft" or "handoff_task". */
  kind: string;
  id: string;
  status: string;
  at: string;
}

export interface AiActivitySummary {
  windowDays: number;
  intakeDrafts: IntakeDraftStats;
  handoffTasks: HandoffStats;
  dailyIntakeCounts: DailyCount[];
  recent: ActivityEntry[];
}

export const aiActivityApi = {
  summary(days = 7): Promise<AiActivitySummary> {
    return apiClient
      .get<AiActivitySummary>("/v1/integrations/ai-assistant/activity", {
        params: { days },
      })
      .then((r) => r.data);
  },
};

export const aiActivityQueryKeys = {
  summary: (days: number) => ["ai-activity", "summary", days] as const,
};

export function conversionRatePct(stats: IntakeDraftStats): number {
  if (!stats.created) return 0;
  return Math.round((stats.converted / stats.created) * 1000) / 10;
}
